/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Update S3 inventory configuration. If systemControlled is true, sets config to \'auto\' (system decides when to use inventory). If systemControlled is false, must provide enabled to set \'force-true\' or \'force-false\' (user controls inventory usage).
*/
export class UpdateCloudResourceConfigurationRequestInventoryBackup {
  /**
  * Whether inventory is enabled. Required when systemControlled is false. Ignored when systemControlled is true.
  */
  'enabled'?: boolean | null;
  /**
  * Whether to let the system decide when to use inventory (true = \'auto\', false = user controls with \'force-true\'/\'force-false\')
  */
  'systemControlled'?: boolean | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "enabled",
      "baseName": "enabled",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "systemControlled",
      "baseName": "systemControlled",
      "type": "boolean",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return UpdateCloudResourceConfigurationRequestInventoryBackup.attributeTypeMap;
  }

  public constructor() {
  }
}

